module.exports = __webpack_public_path__ + "img/ssfv.aaaa57e1.png";